import React from 'react';
import { MegaphoneIcon } from 'lucide-react';

import PageContainer from '@/components/layout/PageContainer';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import NpsCampaignsTable from './NpsCampaignsTable';

const NpsCampaigns: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();
  const canList = checkAuthorization(({ can }) => can('list', 'nps'));

  if (!canList) {
    return (
      <PageContainer title="NPS">
        <Alert>
          <MegaphoneIcon data-icon="inline-start" />
          <AlertTitle>Acesso negado</AlertTitle>
          <AlertDescription>
            Você não tem permissão para listar campanhas NPS.
          </AlertDescription>
        </Alert>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="NPS">
      <NpsCampaignsTable />
    </PageContainer>
  );
};

export default NpsCampaigns;
